import * as routes from '../../App/routeConstants';
import {creditCard, person, puzzle, dollar, settings, receipt, gavel, amazon} from 'cl-icons';
import * as _ from 'lodash';

export interface AccountPageEntryProps {
  referenceTransactionEnabled: boolean;
  referralProgram: any;
}

export interface AccountPageEntry {
  iconPath: string;
  label: string;
  route?: string;
  getRoute?: (props: AccountPageEntryProps) => string;
  getLabel?: (props: AccountPageEntryProps) => string;
}

function titleToRoute(title: string) {
  return title.toLocaleLowerCase().replace(/ /g, '-');
}

export const PlanAndBilling: Partial<AccountPageEntry> = {};
PlanAndBilling.iconPath = creditCard;
PlanAndBilling.label = 'Plan & Billing';
PlanAndBilling.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(PlanAndBilling.label)}`;
PlanAndBilling.getRoute = props => {
  const {referenceTransactionEnabled} = props;
  if (!referenceTransactionEnabled) {
    return routes.MyAccount.Upgrade;
  }
  return PlanAndBilling.route;
};

export const Profile: Partial<AccountPageEntry> = {};
Profile.iconPath = person;
Profile.label = 'Profile';
Profile.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(Profile.label)}`;

export const Settings: Partial<AccountPageEntry> = {};
Settings.iconPath = settings;
Settings.label = 'eBay settings';
Settings.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(Settings.label)}`;

export const Integrations: Partial<AccountPageEntry> = {};
Integrations.iconPath = puzzle;
Integrations.label = 'Integrations';
Integrations.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(Integrations.label)}`;

export const EBayAccounts: Partial<AccountPageEntry> = {};
EBayAccounts.iconPath = gavel;
EBayAccounts.label = 'eBay Accounts';
EBayAccounts.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(EBayAccounts.label)}`;

export const AmazonAccounts: Partial<AccountPageEntry> = {};
AmazonAccounts.iconPath = amazon;
AmazonAccounts.label = 'Amazon Accounts';
AmazonAccounts.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(AmazonAccounts.label)}`;

export const Referrals: Partial<AccountPageEntry> = {};
Referrals.iconPath = dollar;
Referrals.label = 'Referrals';
Referrals.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(Referrals.label)}`;
Referrals.getLabel = props => {
  const {referralProgram} = props;
  return 'Earn US $' + _.get(referralProgram, 'referrerRewardAmount');
};

export const BillingHistory: Partial<AccountPageEntry> = {};
BillingHistory.iconPath = receipt;
BillingHistory.label = 'Billing History';
BillingHistory.route = `${routes.MyAccount.AccountPageBase}/${titleToRoute(BillingHistory.label)}`;
